/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Facts_Platform_ValueInputs */

const en_gc_resources_facts_platform_value = /** @type {(inputs: Gc_Resources_Facts_Platform_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop + web`)
};

const zh_gc_resources_facts_platform_value = /** @type {(inputs: Gc_Resources_Facts_Platform_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桌面与网页`)
};

/**
* | output |
* | --- |
* | "Desktop + web" |
*
* @param {Gc_Resources_Facts_Platform_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_facts_platform_value = /** @type {((inputs?: Gc_Resources_Facts_Platform_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Facts_Platform_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_facts_platform_value(inputs)
	return zh_gc_resources_facts_platform_value(inputs)
});
export { gc_resources_facts_platform_value as "gc.resources.facts.platform.value" }